import {CreateView} from '@src/components/_views/configurable/CreateView';
import {withRouterApi} from '@src/HOCs/withRouterApi';
import {FormViewProps} from '@src/@types/components/FormViewProps';
import ChecklistForm from './ChecklistForm';

export class ChecklistCreateForm extends CreateView {
    protected getFormComponent() {
        return ChecklistForm;
    }
}

export default ChecklistCreateForm.getStoreConnector()(withRouterApi<FormViewProps>(ChecklistCreateForm));
